import { render, staticRenderFns } from "./WechatMarketing.vue?vue&type=template&id=b114dfec&scoped=true"
import script from "./WechatMarketing.vue?vue&type=script&lang=js"
export * from "./WechatMarketing.vue?vue&type=script&lang=js"
import style0 from "./WechatMarketing.vue?vue&type=style&index=0&id=b114dfec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b114dfec",
  null
  
)

export default component.exports